import { motion } from "framer-motion";

/**
 * Wrap any element/section in <Reveal> to give it a fade + slide-up
 * animation the first time it scrolls into view.
 *
 * Props:
 *  - direction: "up" | "down" | "left" | "right" | "none"
 *  - delay: number (seconds) — stagger children by passing 0, 0.1, 0.2...
 *  - width: "full" | "fit" — set to "fit" for inline elements
 */
const OFFSETS = {
  up: { y: 40, x: 0 },
  down: { y: -40, x: 0 },
  left: { y: 0, x: 40 },
  right: { y: 0, x: -40 },
  none: { y: 0, x: 0 },
};

export default function Reveal({
  children,
  direction = "up",
  delay = 0,
  duration = 0.6,
  className = "",
  width = "full",
}) {
  const offset = OFFSETS[direction] || OFFSETS.up;

  return (
    <motion.div
      className={`${width === "full" ? "w-full" : "w-fit"} ${className}`}
      initial={{ opacity: 0, y: offset.y, x: offset.x }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
